module.exports = __webpack_public_path__ + "static/media/ico_arrow_down_white.6097f0b8.svg";